import ReactGA from "react-ga4";
import { AnalyticsEventMap } from "./analyticsEvents.web";

const ENV = process.env.REACT_APP_ENV;
const GA_ID = process.env.REACT_APP_GA_MEASUREMENT_ID || "";

const isAnalyticsEnabled = ENV === "production" && !!GA_ID;

export const initAnalytics = (): void => {
  if (isAnalyticsEnabled) {
    ReactGA.initialize(GA_ID);
  } else {
    console.debug(`Analytics not initialized (ENV=${ENV}, GA_ID=${GA_ID ? "set" : "missing"})`);
  }
};

export const setUserIdForAnalytics = (userId: string | number): void => {
  if (isAnalyticsEnabled) {
    ReactGA.set({ user_id: userId });
  } else {
    console.debug(`User ID set skipped for ENV=${ENV}`, userId);
  }
};

export const clearUserIdFromAnalytics = (): void => {
  if (isAnalyticsEnabled) {
    ReactGA.set({ user_id: null });
  } else {
    console.debug(`User ID cleared skipped for ENV=${ENV}`);
  }
};

export const logEvent = <T extends keyof AnalyticsEventMap>(
  eventName: T,
  params: AnalyticsEventMap[T]
): void => {
  if (isAnalyticsEnabled) {
    ReactGA.event(eventName as string, params);
  } else {
    console.debug(`Analytics Event [${eventName}] skipped (ENV=${ENV})`, params);
  }
};

export const logPageView = (path: string): void => {
  if (isAnalyticsEnabled) {
    ReactGA.send({ hitType: "pageview", page: path });
  } else {
    console.debug(`Pageview skipped (ENV=${ENV})`, path);
  }
};
